import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const options = [
  {label: 'Porcentagem', value: 'percentage'},
  {label: 'Fixo', value: 'fixed'},
]

export const strategy = optionsToStrategy(options)